export enum QuestType {
  TELEGRAM = "telegram",
  SIMPLE = "simple"
}

export enum QuestConditionCode {
  HAS_LABR_USER = "has_labr_user",
  EXPEDITION_FINISHED = "expedition_finished",
  DIGGING_CYCLE_FINISHED = "digging_cycle_finished"
}

export interface IQuest {
  _id: string
  title: string // raw text
  type: QuestType
  rewardGoldenDust: number
  url?: string
  imageUrl?: string
  telegramChatId?: string
  conditionCode?: QuestConditionCode | null
  conditionThreshold?: number | null
}

export interface IQuestCompletedRaw {
  _id: string
  player: string
  quest: string // ObjectId — raw shape returned by POST /:id/claim
  isClaimed: boolean
  completedAt: string // ISO
}

export interface IQuestCompleted extends Omit<IQuestCompletedRaw, "quest"> {
  quest: IQuest // populated by backend on /me/completed
}

export interface IGetMyCompletedRes {
  items: IQuestCompleted[]
  total: number
}

export interface IGetMyProgressRes {
  progress: Record<string, boolean>
}
